import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsService {
    #appInsights: ApplicationInsights | null = null
    #userId: number | null = null
    #companyId: number | null = null

    initialize(connectionString: string | null): void {
        if (!connectionString || this.#appInsights || this.#userId === null || this.#companyId === null) {
            return
        }

        this.#appInsights = new ApplicationInsights({
            config: {
                connectionString,
                autoTrackPageVisitTime: true,
                enableAutoRouteTracking: true,
            },
        })

        this.#appInsights.loadAppInsights()

        this.#appInsights.addTelemetryInitializer((envelope) => {
            envelope.tags ??= {}
            envelope.tags['ai.cloud.role'] = 'Surequote.Spa'

            if (this.#userId !== null) {
                envelope.data ??= {}
                envelope.data['surequote.user.id'] = this.#userId.toString()
                envelope.data['surequote.company.id'] = this.#companyId?.toString() ?? ''
            }
        })

        this.#appInsights.trackPageView()
    }

    identifyUser(userId: number, companyId: number): void {
        this.#userId = userId
        this.#companyId = companyId

        this.#appInsights?.setAuthenticatedUserContext(userId.toString(), companyId.toString(), true)
    }

    trackEvent(name: string, properties?: Record<string, string>, measurements?: Record<string, number>): void {
        this.#appInsights?.trackEvent({ name, properties, measurements })
    }

    trackException(exception: Error, properties?: Record<string, string>, measurements?: Record<string, number>): void {
        this.#appInsights?.trackException({ exception, properties, measurements })
    }
}
